import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogAddAttachments',
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {



//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK } = useDialogPluginComponent()

const title = t("sfxDialogAddAttachments.title")
const body = t("sfxDialogAddAttachments.body")
const hint = t("sfxDialogAddAttachments.hint")
const btnSearchAttachments = t("sfxButtons.btn_search_attachments")
const btnUploadNewFile = t("sfxButtons.btn_upload_new_file")

//endregion

//region Functions

function handleClick(number: 1 | 2) {
  if (number === 1) return showNotImplementedNotification()
  onDialogOK(number)
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 q-pb-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(body) }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-caption text-fun-label-and-icon q-pb-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(hint) }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: _unref(btnSearchAttachments),
                class: "col",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick(1)))
              }, null, 8, ["label"]),
              _createVNode(SfxBtn, {
                label: _unref(btnUploadNewFile),
                class: "col",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick(2)))
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})